<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <!-- <Breadcrumb
      :items="items"
        :canAddNew="!canAdd"
      icon="fa-plus"
    /> -->
    <!-- End Breadcrumb -->
    <!-- <main-filter
      @getResult="setRows"
      categories
      code
      price
      withCategory
      withSizes
      withColors
    /> -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="fadeIn" v-else>
      <!-- Start Main Section -->
      <main>
        <v-data-table
          class="elevation-1 thumb diff_table"
          :headers="headers"
          :items="rows"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Start:: Users Routes -->
          <template v-slot:[`item.cv`]="{ item }">
            <div class="item-with-img">
              <a :href="item.cv" v-if="item.cv" download target="_blank">
                <i class="fas fa-download"></i>
              </a>
              <span v-else>---</span>
            </div>
          </template>
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <!-- <v-icon class="show" small @click="showItem(item)">
                fal fa-eye
              </v-icon> -->
              <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
              <v-icon
                class="delete"
                v-if="!canDelete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="table-title title">المتقدمين للوظائف</h3>
            <!-- Delete dialog -->
            <!-- <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t('table.deletedialog.areYouSure') }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t('table.deletedialog.ok') }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t('table.deletedialog.cancel') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>

      <!-- End Statistics Card-->

      <!-- Delete dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5 justify-center">
            {{ $t("table.deletedialog.areYouSure") }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#fff" @click="deleteItemConfirm">
              {{ $t("table.deletedialog.ok") }}
            </v-btn>
            <v-btn color="#fff" @click="dialogDelete = false">
              {{ $t("table.deletedialog.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container tw-text-center mb-5 d-flex justify-content-end"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  components: {
    MainFilter,
    BlogCard: () => import("../../../components/UI/cards/blog.vue"),
  },
  data() {
    return {
      blogs: [
        {
          id: 1,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "30 Oct 2022",
          img: require("@/assets/images/blog/s1.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 2,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "20 Oct 2022",
          img: require("@/assets/images/blog/s2img3.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 3,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "25 Oct 2022",
          img: require("@/assets/images/blog/s2img2.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 4,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "20 Oct 2022",
          img: require("@/assets/images/blog/s2img3.png"),
          views: 2433,
          type: "Business",
        },
        {
          id: 5,
          description:
            "We aim to deliver high-quality products. Hence, we take care of everything at the granular level.",
          title: "The Complete Guide to Web Hosting",
          date: "25 Oct 2022",
          img: require("@/assets/images/blog/s2img2.png"),
          views: 2433,
          type: "Business",
        },
      ],
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.careers.title"),
          disabled: false,
          href: "/careers",
        },
        {
          text: this.$t("breadcrumb.careers.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 15,
      },
      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "اسم المتقدم",
            align: "center",
            value: "fullname",
            sortable: true,
          },
          {
            text: "البريد الالكتروني ",
            align: "center",
            value: "email",
            sortable: true,
          },
          {
            text: "الهاتف",
            align: "center",
            value: "phone",
            sortable: true,
          },
          {
            text: " الوظيفة",
            align: "center",
            value: "career.title",
            sortable: true,
          },
          {
            text: "الرسالة",
            align: "center",
            value: "message",
            sortable: true,
          },

          {
            text: " السيرة الذاتية ",
            align: "center",
            value: "cv",
          },
          {
            text: "الاجراءات",
            align: "center",
            value: "actions",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/career-applicant/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/career-applicant/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/career-applicant/edit/" + item.id });
    },
    addMeta(item) {
      this.$router.push({ path: "/career-applicant/meta/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `career_applicant/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("page", this.paginations.current_page);
      // params.append('keyword', e?.searchInput ? e.searchInput : '')
      // params.append('code', e?.code ? e.code : '')
      // params.append('from_price', e?.start_price ? e.start_price : '')
      // params.append('to_price', e?.end_price ? e.end_price : '')
      // params.append(
      //   'category_id',
      //   e?.selectedCategory ? e.selectedCategory.id : '',
      // )
      // params.append('size', e?.size ? e.size.id : '')
      // params.append('color', e?.color ? e.color.id : '')

      // if (e?.feature) {
      //   e.feature.map((el, index) => {
      //     params.append(`features[${index}]`, el.id)
      //   })
      // }
      this.axios({
        method: "GET",
        url: "career_applicant",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.rows = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },

  // ======= hooks
  created() {
    this.canEdit = this.$permission.allowed("career-applicant/edit/");
    this.canDelete = this.$permission.allowed("career-applicant/delete");
    this.canAdd = this.$permission.allowed("career-applicant/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 120px;
  img {
    width: 100%;
  }
}
</style>
